import {SmartLibraryApplication} from "./enums/smart-library-application.enum";

export class DeploymentDto {
    id: number;
    terminalId: number;
    application: SmartLibraryApplication;
    version: string;

    requestedDateUtc: Date;
    consumedDateUtc: Date;
    appliedDateUtc: Date;

    restartAfterUpdate: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/deployment.dto.ts